// extracted by mini-css-extract-plugin
export default {"header":"menu_header__ULB0I","logo":"menu_logo__dMqrh","nav":"menu_nav__Jgmku","active":"menu_active__CDBGK"};